import { useSelector } from 'react-redux';
import { SERVICE } from 'self-service-api/constants/ProductLines';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { ENTERPRISE } from '../../constants/routing/Tabs';
import { usePageParams } from '../../hooks/usePageParams';
import { useAppSelector } from '../../reducers';
import { isUngatedForJune24PriceChangesSelector, isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { hasAnyTBSkuInProductDataSelector } from '../../selectors/ProductsSelectors';
import { isRussianBlockedSelector } from '../../selectors/PurchaseMotionSelectors';
import CustomerPlatformPriceChangeBanner from './CustomerPlatformPriceChangeBanner';
import RussianBlockedBanner from './RussianBlockedBanner';
import ServiceHubPriceChangeBanner from './ServiceHubEntPriceChangeBanner';
import { jsx as _jsx } from "react/jsx-runtime";
const BannerHierarchySection = ({
  productLine,
  navItem
}) => {
  const {
    tab
  } = usePageParams();
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  const isRussianBlocked = useSelector(isRussianBlockedSelector);
  const showJune24PriceChanges = useAppSelector(state => {
    const isUngated = isUngatedForJune24PriceChangesSelector(state);
    const isUngatedForSeats = isUngatedForSeatsSelector(state);
    const isSeatsTBPortal = hasAnyTBSkuInProductDataSelector(state);

    // Price change only applies to pre-seats & tb portals, not seats non-tb portals
    return isUngated && (!isUngatedForSeats || isUngatedForSeats && isSeatsTBPortal);
  });
  if (!hasPricingAndPurchasingSucceeded) {
    return null;
  }
  if (isRussianBlocked) {
    return /*#__PURE__*/_jsx(RussianBlockedBanner, {});
  }
  if (showJune24PriceChanges) {
    if (productLine === SERVICE && (!tab || tab === ENTERPRISE)) {
      return /*#__PURE__*/_jsx(ServiceHubPriceChangeBanner, {});
    }
    if (navItem === NavItemEnum.SUITE) {
      return /*#__PURE__*/_jsx(CustomerPlatformPriceChangeBanner, {});
    }
  }
  return null;
};
export default BannerHierarchySection;